import React from 'react';
import Section from '../common/Section';
import Slider from 'react-slick';
import Image from '../common/Image';
import {getStaticPath} from '../../utils';
import { NextArrow, PrevArrow } from '../common/ui-components/carosel';
import slick_styles from '../../styles/modules/ui-components/carosel.module.scss';
import styles from '../../styles/modules/common/Awards.module.scss';
import '../../styles/modules/ui-components/carosel.module.scss';

interface Props {
    IsHeading: boolean,
    fromHome?:boolean
}


const PARTNER_DETAILS = [   
        // National Partners
        {'image': 'amazon.webp', 'name': 'Amazon'}, 
        {'image': 'National_Partners_Croma.webp', 'name': 'NationalPartnersCroma'}, 
        {'image': 'National_Partners_Vijay_Sales.webp', 'name': 'NationalPartnersVijaySales'},
        
        // Banking partners
        {'name': 'BankingpartnerICICIBank', 'image': 'Banking_partner_ICICI_Bank.webp'}, 

        // Apple Logos
        {'image': 'Apple_Partners_Delta.webp', 'name': 'ApplePartnersDelta'}, 
        {'image': 'Apple_Partners_destiny.png', 'name': 'ApplePartnersdestiny'},
        {'image': 'Apple_Partners_IAspire.png', 'name': 'ApplePartnersIAspire'}, 
        {'image': 'Apple_Partners_IAvenue.png', 'name': 'ApplePartnersIAvenue'}, 
        {'image': 'Apple_Partners_Icrest.png', 'name': 'ApplePartnersIcrest'}, 
        {'image': 'Apple_Partners_IEmpire.png', 'name': 'ApplePartnersIEmpire'}, 
        {'image': 'Apple_Partners_Ifuture.png', 'name': 'ApplePartnersIfuture'}, 
        {'image': 'Apple_Partners_iMagic.png', 'name': 'ApplePartnersiMagic'}, 
        {'image': 'Apple_Partners_INvent.png', 'name': 'ApplePartnersINvent'}, 
        {'image': 'Apple_Partners_Ipearl.png', 'name': 'ApplePartnersIpearl'}, 
        {'image': 'Apple_Partners_Isense.png', 'name': 'ApplePartnersIsense'}, 
        {'image': 'Apple_Partners_Itronics.png', 'name': 'ApplePartnersItronics'}, 
        {'image': 'Apple_Partners_Iwish.png', 'name': 'ApplePartnersIwish'}, 
        {'image': 'Apple_Partners_Tech_Next.png', 'name': 'ApplePartnersTechNext'}, 

        // Regional Partner
        {'image': 'Unilet.webp', 'name': 'RegionalPartnersUnilet'},
        {'image': 'Supreme_Mobiles.webp', 'name': 'RegionalPartnersSupremeMobiles'},
        {'image': 'BigC.webp', 'name': 'RegionalPartnersBigC'},
        {'image': 'Lot.webp', 'name': 'RegionalPartnersLot'},
        {'image': 'Pittapillil.webp', 'name': 'RegionalPartnersPittapillil'},
        {'image': 'QRS.webp', 'name': 'RegionalPartnersQRS'},
        {'image': 'Viveks.webp', 'name': 'RegionalPartnersViveks'},
        {'image': 'Regional_Partners_Anandamela.png', 'name': 'RegionalPartnersAnandamela'}, 
        {'image': 'Regional Partners_Bajaj_Elec.png', 'name': 'Regional PartnersBajaj Elec'},
        {'image': 'Regional_Partners_Electronics_Mart.png', 'name': 'ElectronicsMart'},  
        {'image': 'Regional_Partners_Bharat.png', 'name': 'RegionalPartnersBharat'}, 
        {'image': 'Regional_Partners_Devi.png', 'name': 'RegionalPartnersDevi'}, 
        {'image': 'Regional_Partners_Getco.png', 'name': 'RegionalPartnersGetco'}, 
        {'image': 'Regional_Partners_Girias.png', 'name': 'RegionalPartnersGirias'},
        {'image': 'Regional_Partners_GOMOBILE.png', 'name': 'RegionalPartnersGOMOBILE'}, 
        {'image': 'Regional_Partners_GreatEastern.png', 'name': 'RegionalPartnersGreatEastern'}, 
        {'image': 'Regional_Partners_Hariom.png', 'name': 'RegionalPartnersHariom'}, 
        {'image': 'Regional_Partners_Harsha.png', 'name': 'RegionalPartnersHarsha'}, 
        {'image': 'Regional_Partners_Hotspot.png', 'name': 'RegionalPartnersHotspot'},
        {'image': 'Regional_Partners_Khosla.png', 'name': 'RegionalPartnersKhosla'}, 
        {'image': 'Regional_Partners_Kohinoor.png', 'name': 'RegionalPartnersKohinoor'}, 
        {'image': 'Regional_Partners_Oline.png', 'name': 'RegionalPartnersOline'}, 
        {'image': 'Regional_Partners_Patra.png', 'name': 'RegionalPartnersPatra'},
        {'image': 'Regional_Partners_Sanket.png', 'name': 'RegionalPartnersSanket'}, 
        {'image': 'RegionalPartners_Sathya.png', 'name': 'RegionalPartnersSathya'}, 
        {'image': 'Regional_Partners_Sonovision.png', 'name</div>': 'RegionalPartnersSonovision'},  
        {'image': 'Regional_Partners_TheChennaiMobiles.png', 'name': 'RegionalPartnersTheChennaiMobiles'}, 
        {'image': 'Regional_Partners_TOP10.png', 'name': 'RegionalPartnersTOP10'}, 
        {'image': 'Regional_Partners_ValuePlus.png', 'name': 'RegionalPartnersValuePlus'}, 

        // Consumer Finance Partners
        {'image': 'Consumer_finance_partners_HDB.png', 'name': 'ConsumerfinancepartnersHDB'},
        {'image': 'Consumer_finance_partners_HOME_CREDIT.png', 'name': 'HOME CREDIT'}, 
    ]

const Partners = (props: Props) => {
    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        nextArrow: <NextArrow type="partners"/>,
        prevArrow: <PrevArrow type="partners"/>,


        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    autoplay: true,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    rows: 2,
                    autoplay: true,
                }
            }
        ]
    };
    const { IsHeading } = props
    return (
            <Section title="Our Partners" hasPadding={true} subtitle={IsHeading ? "SPOTLIGHT" : ""} noTitleEL={false}  className={`partners ${ props.fromHome ? "section_custompad" : ""}`}>
                <div className="container">
                    <div>
                            <Slider className={`app-list-carosel ${styles.slick_slider} ${slick_styles.slick_slider}`} {...settings}>
                            
                            {PARTNER_DETAILS.map((item,index) => {
                                return (
                                    <div className={`${styles.partners_div}`} key={index}>
                                    <Image src={getStaticPath(`/static/images/logos/${item.image}`)} key={item.name} width="200" height="80" alt={item.name} unoptimized={true} />
                                    </div>
                                )
                            }
                            )}
                        </Slider>
                    </div>
                </div>
            </Section>
    )
}



export default Partners;
